<form [formGroup]="signUpForm">
  <app-input-form
    label="Username *"
    icon="person"
    [note]="userError || 'ชื่อผู้ใช้มีความยาว 6-255 ตัวอักษร ( a-z 0-9 _ . )'"
    [error]="!!userError"
  >
    <input
      type="text"
      id="username"
      formControlName="user"
      placeholder="Username"
      required
      minlength="6"
      maxlength="255"
      (keyup.enter)="doSignUp()"
    />
    @if (userError) {
      <i class="material-icons error-icon">error</i>
    }
  </app-input-form>
  <app-input-form label="Email *" icon="email" [note]="emailError" [error]="!!emailError">
    <input
      type="text"
      id="email"
      formControlName="email"
      placeholder="Email"
      required
      (keyup.enter)="doSignUp()"
    />
    @if (userError) {
      <i class="material-icons error-icon">error</i>
    }
  </app-input-form>
  <app-input-form
    label="Password *"
    icon="lock"
    [note]="passwordError || 'รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร'"
    [error]="!!passwordError"
  >
    <input
      type="password"
      formControlName="password"
      placeholder="Password"
      required
      (keyup.enter)="doSignUp()"
    />
    @if (passwordError !== undefined) {
      <i class="material-icons error-icon">error</i>
    }
  </app-input-form>
  <app-input-form
    label="Confirm Password *"
    icon="lock"
    [note]="confirmPasswordError"
    [error]="!!confirmPasswordError"
  >
    <input
      type="password"
      formControlName="confirmPassword"
      placeholder="Confirm Password"
      required
      (keyup.enter)="doSignUp()"
    />
    @if (passwordError) {
      <i class="material-icons error-icon">error</i>
    }
  </app-input-form>
</form>

<div class="footer-button">
  <button mat-button appButton (click)="goBackFunc()">ย้อนกลับ</button>
  <button mat-raised-button appThemedButton (click)="doSignUp()">สมัครสมาชิก</button>
</div>
